import { render, staticRenderFns } from "./add-province.vue?vue&type=template&id=075c238e"
import script from "./add-province.vue?vue&type=script&lang=js"
export * from "./add-province.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports